import { styled, Typography } from "@mui/material";


export const RangeSelector = styled(Typography)({
    textAlign: 'center',

    color: '#9e9e9e',
    fontFamily: 'Rubik',
    fontSize: '12px',
    lineHeight: '14px',
    fontWeight: 700
})